// extracted by mini-css-extract-plugin
export var addToCartButton = "_sd-b";
export var arrowButtonContainer = "_sd-9";
export var arrowButtonIcon = "_sd-a";
export var carouselArrowButton = "_sd-6";
export var carouselElementContainer = "_sd-1";
export var galleryThumbnail = "_sd-d";
export var galleryThumbnailImage = "_sd-e";
export var left = "_sd-7";
export var productDisplayCarouselContainer = "_sd-0";
export var productTileContainer = "_sd-2";
export var productTileImage = "_sd-4";
export var productTileImageContainer = "_sd-3";
export var productTileTitle = "_sd-5";
export var right = "_sd-8";
export var sliderOverflow = "_sd-c";